module.exports = __webpack_public_path__ + "static/www/img/course_coding.d686b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/course/course_coding.jpg
// module id = 379
// module chunks = 1